import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import CONFIG from "@bd-core/config";
import {
    getRoomStatus,
    getFinalTeamAnswers,
    getHintUsed,
} from "@bd-stores/game-progress";
import IntroVideo from "@bd-utils/intro-video-room";
import OutroVideo from "@bd-utils/outro-video-room";
import Hints from "@bd-utils/hints";
import {
    maybeUpdateRoomStatus,
    saveFinalRoomAnswers,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import { getRoomAnswerById } from "@bd-stores/game-data";
import CompletionPopup from "@bd-utils/completion-popup";

export class RoomRethink extends BD_Component {
    constructor() {
        super();

        this.id = "rethink";
        this.templateID = "rethink-template";

        this.elms = {
            submitBtn: ".js-submit-answer.answer",
            answerInput: ".js-answer-input",
            answerBox: ".answerBox",
            hint: ".hint",
            clue: ".js-clue",
            cluePopup: ".js-clue-popup",
            closeCluePopup: ".js-close-clue-popup",
            item: ".rethink__item",
        };

        this._events = this.getEvents();

        this.hints = new Hints();
        this.popupHint = [];
        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onClickedSubmit,
            },
            {
                event: "keydown",
                selector: elms.answerInput,
                handler: this.onAnswerInput,
            },
            {
                event: "keyup",
                selector: elms.answerInput,
                handler: this.onAnswerInputKeyUp,
            },
            {
                event: "click",
                selector: elms.clue,
                handler: this.onClueClick,
            },
            {
                event: "click",
                selector: elms.closeCluePopup,
                handler: this.closeCluePopup,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.initIntroVideo();
        this.initOutroVideo();
        this.initHints();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const hotspots = this._data.hotspots;

        // if `default_image` is not set in the admin, we will use this fallback image
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/matchcards-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const newHints = this._data.hints.map((hint, i) => {
            this.popupHint.push({ ...hint });

            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: newHints,
            hintProps: CONFIG.game.hintProp,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const isHintUsed = getHintUsed(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (thisRoomStatus == "is-status-completed") {
            const finalRoomAnswers = getFinalTeamAnswers(roomID);

            this.completionPopup.show(roomID, false, finalRoomAnswers);

            $(elms.answerInput)
                .addClass("is-locked")
                .prop("disabled", true)
                .html(`${finalRoomAnswers}`);
            $(elms.submitBtn).prop("disabled", true);

            $(".app__page").addClass("is-room-completed");
        }

        if (isHintUsed) {
            $(".hint").addClass("is-used");
        } else {
            $(".hint").removeClass("is-used");
        }
    }

    // ============================== CUSTOM FUNCTION
    onClueClick(e) {
        e.preventDefault();
        const elms = this.elms;
        const currentTarget = $(e.currentTarget);
        const parent = currentTarget.parents(elms.item);
        if(!parent.hasClass("is-open-popup")) return;

        const $cluePopup = $(elms.cluePopup);
        const panelId = parent.attr("data-panel-id");
        const videoSrc = this._data.items.find((item) => item.panel_id === panelId).video;

        $cluePopup.addClass("is-open");
        const $video = $cluePopup.find("video");

        $video.attr("src", videoSrc);
        if($video.attr("src") !== undefined) {
            $video.each(function (_idx, el) {
                if (el && typeof el.pause === "function") {
                    el.play();
                }
            });
        }
    }

    closeCluePopup() {
        const elms = this.elms;
        const $cluePopup = $(elms.cluePopup);
        $cluePopup.removeClass("is-open");
        const $video = $cluePopup.find("video");

        $video.each(function (_idx, el) {
            if (el && typeof el.pause === "function") {
                el.pause();
                el.currentTime = 0;
            }
        });

    }

    initIntroVideo() {
        this.introVideo = new IntroVideo();
        this.introVideo.initForRoom("rethink", "intro-video-rethink");
    }

    initOutroVideo() {
        this.outroVideo = new OutroVideo();
        this.outroVideo.initForRoom("rethink", "outro-video-rethink");
    }

    onClickedSubmit() {
        const userAnswer = $(this.elms.answerInput).val().toString().trim();
        if (!userAnswer) return;

        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        let roomStatus = "is-status-started";

        let roomAnswer = getRoomAnswerById(roomID);
        const isCorrect = roomAnswer.includes(userAnswer);
        const state = isCorrect ? "is-correct" : "is-incorrect";
        $(this.elms.answerBox).addClass(state);

        if (isCorrect) {
            roomStatus = "is-status-completed";

            this.outroVideo.startVideo();

            updateRoomAnswer(roomID, {
                [currentPlayerId]: {
                    answers: userAnswer,
                    isCorrect: isCorrect,
                },
            });
            saveFinalRoomAnswers(roomID, userAnswer);
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    onAnswerInput(e) {
        const elms = this.elms;
        const $answerInput = $(elms.answerInput);
        const answer = $answerInput.val();
        const isEnterKey = e.key === "Enter" || e.keyCode === 13;

        if (isEnterKey) {
            e.preventDefault();
            const hasValue = String(answer).length > 0;
            if (hasValue) {
                $(elms.submitBtn).trigger("click");
            }
        } else {
            $(this.elms.answerBox).removeClass("is-incorrect");
        }
    }

    onAnswerInputKeyUp() {
        const elms = this.elms;
        const $answerInput = $(elms.answerInput);
        const answer = $answerInput.val();
        const hasValue = String(answer).length > 0;
        $(elms.submitBtn).prop("disabled", !hasValue);
    }

    initHints() {
        this.hints.init(this.roomId, this.popupHint);
    }

    beforeDestroy() {
        if (this.introVideo) {
            this.introVideo.cleanup();
            this.introVideo = null;
        }

        if (this.outroVideo) {
            this.outroVideo.cleanup();
            this.outroVideo = null;
        }
    }
}
